export const INVOICE_FETCH = 'INVOICE_FETCH';
export const INVOICE_RECALL = 'INVOICE_RECALL';
export const INVOICE_ADMIN_CONFIRM = 'INVOICE_ADMIN_CONFIRM';
export const INVOICE_GENERATE = 'INVOICE_GENERATE';
